import { get, isNil, set } from 'lodash';

export const trySetProp = <T extends Record<any, any>, P extends keyof T>(obj: T, propName: P, propValue: T[P]) => {
  if (isNil(get(obj, propName))) {
    set(obj, propName, propValue);
  }
};
